export interface ThesisPillar {
  index: string
  title: string
  lead?: string
  detail: string
}

export const thesisPillars: ThesisPillar[] = [
  {
    index: '01',
    title: 'Differentiated product',
    detail:
      'AI that handles real calls through the telecom layer. Not another standalone AI application.',
  },
  {
    index: '02',
    title: 'One platform. Multiple products.',
    lead: 'VEXU App · VEXU Business · Future verticals',
    detail:
      'Shared voice, conversation, memory, actions, workflows and integrations.',
  },
  {
    index: '03',
    title: 'Multiple distribution paths',
    lead: 'Direct · Influencers & Affiliates · Product-led · Telecom',
    detail: 'Multiple acquisition loops feeding the same platform.',
  },
  {
    index: '04',
    title: 'Built to expand',
    lead: 'Individuals → Professionals → Businesses → Commerce',
    detail:
      'Expand customer value without rebuilding the underlying platform.',
  },
]

export const thesisStatement =
  'One AI platform. Every conversation. Multiple markets.'

export const thesisScopeNote =
  'VEXU App and VEXU Business drive the current 3-year Base Case. Talab, telecom distribution and additional verticals represent upside beyond the model.'
